var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "home"
  }, [_vm.$vuetify.breakpoint.mdAndUp ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('Supply')], 1), _c('div', {
    staticClass: "card"
  }, [_c('Stake')], 1), _c('div', {
    staticClass: "card"
  }, [_c('Price', {
    staticClass: "info-1"
  })], 1), _c('div', {
    staticClass: "card"
  }, [_c('MarketCap', {
    staticClass: "info-5"
  })], 1), _c('div', {
    staticClass: "card graph"
  }, [_c('ValidatorsHistory')], 1), _c('div', {
    staticClass: "card"
  }, [_c('Fees', {
    staticClass: "info-5"
  })], 1)]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('Supply')], 1), _c('div', {
    staticClass: "card"
  }, [_c('Stake')], 1), _c('div', {
    staticClass: "card"
  }, [_c('Validators', {
    staticClass: "info-1"
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card blockchain"
  }, [_c('p', {
    staticClass: "header"
  }, [_vm._v("Primary Networks")]), _c('p', {
    staticClass: "description"
  }, [_vm._v(" Primary Network, encompassing the ATH, ACT, and AST blockchain. All validators of custom subnets must also be a member of this subnet. ")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "blockchain_container"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._m(0), _c('a', {
    staticClass: "right",
    attrs: {
      "href": _vm.actChainURL
    }
  }, [_c('img', {
    staticClass: "card_icon",
    attrs: {
      "src": require("@/assets/goto_icon.svg")
    }
  })])]), _c('p', {
    staticClass: "content"
  }, [_vm._v(" The Action chain (ACT-chain) runs on an ethereum virtual machine and is used to deploy smart contract and connect to dApps. ")])]), _c('div', {
    staticClass: "blockchain_container"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._m(1), _c('a', {
    staticClass: "right",
    attrs: {
      "href": _vm.astChainURL
    }
  }, [_c('img', {
    staticClass: "card_icon",
    attrs: {
      "src": require("@/assets/goto_icon.svg")
    }
  })])]), _c('p', {
    staticClass: "content"
  }, [_vm._v(" The Asset chain (AST-chain) runs on an dcomm virtual machine for creating and trading digital smart assets and connect with chains. ")])]), _c('div', {
    staticClass: "blockchain_container"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._m(2), _c('a', {
    staticClass: "right",
    attrs: {
      "href": _vm.athChainURL
    }
  }, [_c('img', {
    staticClass: "card_icon",
    attrs: {
      "src": require("@/assets/goto_icon.svg")
    }
  })])]), _c('p', {
    staticClass: "content"
  }, [_vm._v(" The Authority chain (ATH-chain) runs on authority virtual machine and coordinates validators, keep track of active subnets, and enable the creation of new subnets. ")])])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm.currentValidators ? _c('div', {
    staticClass: "validator_list"
  }, [_c('ValidatorDataTable', {
    attrs: {
      "validators": _vm.currentValidators
    }
  })], 1) : _vm._e()])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "left"
  }, [_c('img', {
    staticClass: "card_icon",
    attrs: {
      "src": require("@/assets/chain_act.svg")
    }
  }), _c('span', [_vm._v("ACT-Chain")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "left"
  }, [_c('img', {
    staticClass: "card_icon",
    attrs: {
      "src": require("@/assets/chain_ast.svg")
    }
  }), _c('span', [_vm._v("AST-Chain")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "left"
  }, [_c('img', {
    staticClass: "card_icon",
    attrs: {
      "src": require("@/assets/chain_ath.svg")
    }
  }), _c('span', [_vm._v("ATH-Chain")])]);
}]

export { render, staticRenderFns }